module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'Promotion',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: 'NO',
      show: 'Active',
      title: 'TITLE',
      position: 'FEATURE',
      status: 'STATUS',
      action: 'ACTION',
      ctaText: 'CTA TEXT',
      category: 'CATEGORY',
      country: 'COUNTRY',
      imageVideo: 'IMAGE/VIDEO',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      close: 'Close',
      cancel: 'Cancel',
      view: 'View',
      hide: 'Hidden',
      show: 'Show',
      active: 'Activate',
      activeExist: 'A Promotion has been activated',
      deactivate: 'Deactivate',
      schedule: 'Schedule',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this Promotion?',
      activateContent: 'Once activated, only the Promotion description can be updated.',
      activate: 'Do you want to continue to activate this Promotion?',
      deactivate: 'Do you want to continue to deactivate this Promotion?',
      show: 'Do you want to show this Promotion?',
      hidden: 'Do you want to hidden this Promotion?',
      edit: 'Are you sure to edit this Promotion?',
      close: 'Are you sure to close this Promotion?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    image3x4: 'Please upload a 3*4 image or video',
    title: 'Title',
    description: 'Description',
    videoType: 'Video type',
    videoId: 'Video ID',
    video: 'Video',
    cta: 'CTA',
    ctaText: 'CTA text',
    ctaLink: 'CTA link',
    linkType: 'Page Type',
    feature: 'Feature',
    category: 'Category',
    countries: 'Countries',
    status: 'Status',
    show: 'Show',
    images: 'Promotion image URL',
    btnUpdatePromotion: 'Update',
    btnCreatePromotion: 'Create',
    textColor: 'Text Color',
    colorOpacity: 'Background opacity',
    dragMessage: 'Draft image of Promotion here',
    uploadImage: 'Upload an image/video',
    updatePromotion: 'Update Promotion',
    createPromotion: 'Create Promotion',
    buttonText: 'Button Text',
    link: 'Link',
    contentId: 'Content Id',
    content: 'Content',
    contentFormat: 'Content Format',
    featureDeepLink: 'Feature App Deep Link',
    scheduleTile: 'Schedule Promotion',
    loyaltyTier: 'Loyalty Tier',
  },
  validate: {
    titleBlank: 'Please input Title!',
    featureBlank: 'Please select Feature!',
    countryBlank: 'Please select country!',
    loyaltyTierBlank: 'Please select at least one loyalty tier!',
    statusBlank: 'Status is not be empty!',
    imageBlank: 'Please upload an image/video!',
    imageItemBlank: 'Item image is not be empty!',
    uploadImage: 'There was an error while uploading the image. Please try again.',
    linkBlank: 'Please input a link!',
    linkTypeBlank: 'Please select page type!',
  },
  tab: {
    detail: {
      form: {
        time: {
          title: 'Time',
          startTimePlaceholder: 'Start time',
          endTimePlaceholder: 'End time',
          startDatePlaceholder: 'Start date',
          endDatePlaceholder: 'End date',
        },
        validate: {
          titleBlank: 'Please input title.',
          countryBlank: 'Please select Country',
          descriptionBlank: 'Please input description.',
          startBeforeNow: 'The start date time must be after now.',
          endBeforeNow: 'The end date time must be after now.',
          startBeforeEnd: 'The start date must be before the end date time.',
          startTimeBlank: 'Please input start time.',
          endTimeBlank: 'Please input end time.',
          startDateBlank: 'Please input start date.',
          endDateBlank: 'Please input end date.',
          productNameBlank: 'Please input product name.',
          productDescriptionBlank: 'Please input product description.',
          productVideoTypeBlank: 'Please input product video type.',
          productVideoIdBlank: 'Please input product video id.',
          frequencyBlank: 'Please input push notifications reminder frequency.',
        },
      },
    },
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload an image',
      maxItem: 'Please disable another promotion before enabling a new one.',
    },
    success: {
      updatePromotion: 'Promotion successfully updated.',
      createPromotion: 'Promotion successfully created.',
      deletePromotion: 'Promotion successfully deleted.',
      activatePromotion: 'Promotion successfully activated.',
      deactivatePromotion: 'Promotion successfully deactivated.',
      closePromotion: 'Promotion successfully closed.',
      scheduleTile: 'Promotion successfully scheduled.',
    },
  },
};
